// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__vaXLN","error":"Textarea_error__1EnlQ","readonly":"Textarea_readonly__drkrB","disabled":"Textarea_disabled__3qF3S"};